import { makeAutoObservable } from "mobx";
import { DecisionContext } from "@/dbot/common/commonDomain";
import { Language } from "@/i18n/languages";
import { LocalizedText } from "@/common/common";
import { DecisionType } from "@/common/decisions";
import {
  LocalizedStringFieldModel,
  NumberFieldModel,
  StringFieldModel,
} from "@/common/commonForms";

export type InsertCompanyBoardInArticlesOfAssociation = {
  type: DecisionType.insertCompanyBoardInArticlesOfAssociation;
  paragraph?: number;
  texts?: LocalizedText[];
  titles?: LocalizedText[];
};

export class InsertCompanyBoardInArticlesOfAssociationForm {
  readonly type = DecisionType.insertCompanyBoardInArticlesOfAssociation;
  readonly data?: InsertCompanyBoardInArticlesOfAssociation;
  paragraph: NumberFieldModel;
  texts: LocalizedStringFieldModel[];
  titles: LocalizedStringFieldModel[];

  constructor(
    readonly context: DecisionContext<InsertCompanyBoardInArticlesOfAssociation>,
    data?: InsertCompanyBoardInArticlesOfAssociation,
  ) {
    makeAutoObservable(this, { type: false, data: false }, { autoBind: true });
    this.paragraph = new NumberFieldModel({ value: data?.paragraph, isPositive: true });
    const languages = this.context.inputState?.articles?.languages ?? [Language.NO];
    this.texts = languages.map(
      (l) =>
        new LocalizedStringFieldModel(
          new StringFieldModel({ value: data?.texts?.find((t) => t.language === l)?.text }),
          l,
        ),
    );
    this.titles = languages.map(
      (l) =>
        new LocalizedStringFieldModel(
          new StringFieldModel({ value: data?.titles?.find((t) => t.language === l)?.text }),
          l,
        ),
    );
    this.data = data;
  }

  get languages() {
    return this.context.inputState?.articles?.languages ?? [Language.NO];
  }

  get isProjectLocked(): boolean {
    return this.context.isLocked;
  }

  get isValid(): boolean {
    return Array.from(this.texts.values()).every((t) => t.model.isValid) && this.paragraph.isValid;
  }

  validate(): boolean {
    return (
      Array.from(this.texts.values()).every((t) => t.model.validate()) && this.paragraph.validate()
    );
  }
}
